"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACFileGallery = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var icons_1 = require("@ant-design/icons");
var getFileIcon = function (filename) {
    var _a;
    var extension = (_a = filename.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    switch (extension) {
        case 'pdf':
            return (0, jsx_runtime_1.jsx)(icons_1.FilePdfOutlined, { className: "text-5xl text-red-500" });
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
        case 'webp':
            return (0, jsx_runtime_1.jsx)(icons_1.FileImageOutlined, { className: "text-5xl text-green-500" });
        default:
            return (0, jsx_runtime_1.jsx)(icons_1.FileTextOutlined, { className: "text-5xl text-blue-500" });
    }
};
var isImageFile = function (filename) {
    var _a;
    var extension = (_a = filename.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    return ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'].includes(extension || '');
};
var formatDate = function (date) {
    if (!date)
        return '';
    var d = new Date(date);
    return d.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
};
var ACFileGallery = function (_a) {
    var _b = _a.files, files = _b === void 0 ? [] : _b, _c = _a.openInNewTab, openInNewTab = _c === void 0 ? true : _c, _d = _a.containerClassName, containerClassName = _d === void 0 ? 'grid grid-cols-[repeat(auto-fill,minmax(150px,1fr))] gap-4 p-4' : _d, _e = _a.itemClassName, itemClassName = _e === void 0 ? 'border border-gray-300 rounded-lg p-3 flex flex-col items-center justify-center cursor-pointer transition-all duration-300 bg-gray-50 hover:shadow-lg hover:-translate-y-0.5 relative overflow-hidden' : _e, _f = _a.imageClassName, imageClassName = _f === void 0 ? 'w-full h-[120px] object-cover rounded mb-2' : _f, _g = _a.showFileName, showFileName = _g === void 0 ? true : _g, _h = _a.showDate, showDate = _h === void 0 ? true : _h, _j = _a.emptyMessage, emptyMessage = _j === void 0 ? 'No files uploaded' : _j;
    var handleFileClick = function (file) {
        if (openInNewTab) {
            window.open(file.path, '_blank', 'noopener,noreferrer');
        }
        else {
            window.location.href = file.path;
        }
    };
    if (!files || files.length === 0) {
        return ((0, jsx_runtime_1.jsx)("div", { className: "p-8 text-center text-gray-400 border border-dashed border-gray-300 rounded-lg", children: emptyMessage }));
    }
    return ((0, jsx_runtime_1.jsx)("div", { className: containerClassName, children: files.map(function (file, index) {
            var isImage = isImageFile(file.filename);
            return ((0, jsx_runtime_1.jsxs)("div", { className: "".concat(itemClassName, " group"), onClick: function () { return handleFileClick(file); }, children: [(0, jsx_runtime_1.jsx)("div", { className: "absolute top-2 right-2 bg-black/50 rounded-full w-6 h-6 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300", children: (0, jsx_runtime_1.jsx)(icons_1.EyeOutlined, { className: "text-white text-sm" }) }), isImage ? ((0, jsx_runtime_1.jsx)("img", { src: file.path, alt: file.filename, className: imageClassName, onError: function (e) {
                            var target = e.currentTarget;
                            target.style.display = 'none';
                        } })) : ((0, jsx_runtime_1.jsx)("div", { className: "mb-2", children: getFileIcon(file.filename) })), showFileName && ((0, jsx_runtime_1.jsx)("div", { className: "text-xs font-medium text-center text-gray-800 mt-1 w-full overflow-hidden text-ellipsis line-clamp-2", title: file.filename, children: file.filename })), showDate && file.uploadedAt && ((0, jsx_runtime_1.jsx)("div", { className: "text-[10px] text-gray-500 mt-1 text-center", children: formatDate(file.uploadedAt) }))] }, index));
        }) }));
};
exports.ACFileGallery = ACFileGallery;
